import React from "react";
import { ApplicationState } from "../store";
import { USPState } from "../store/USP";
import { connect } from "react-redux";
import { MessageBox } from "./MessageBox";
import CheckIcon from "@material-ui/icons/Check";
import { useTheme } from "@material-ui/core/styles";
import SvgIcon from "@material-ui/icons/Check";
import { Theme } from "../.themes";

type USPProps = USPState & {};

export const USPMessageBox: React.FC<USPProps> = (props: USPProps) => {
  const theme: Theme = useTheme();

  const element = (theme.icons?.checkmarkIcon && <SvgIcon>{theme.icons?.checkmarkIcon}</SvgIcon>) ?? <CheckIcon />;

  return (
    <MessageBox header={props.Header} variant='plain' icon={element}>
      {props.Text}
    </MessageBox>
  );
};

const stateToProps = (state: ApplicationState) => state.usp;
const dispatcherToProps: USPProps = {};

export default connect(stateToProps, dispatcherToProps)(USPMessageBox);
